export const __ADMINISTRADOR = 'Olimpiada Professores - Administrador';
export const __CENTRAL = 'Olimpiada Professores - Central';
export const __CANDIDATO = 'Olimpiada Professores - Candidato';
export const __COORDENADOR = 'Olimpiada Professores - Coordenador';
export const __APOIO_SECRETARIAL = 'Olimpiada Professores - Apoio Secretarial';
export const __DIGITADOR = 'Olimpiada Professores - Digitador';

export const __ESCOLA_ADICIONAR_OPCOES_AVANCADAS = '__ol-mirim.escola.adicionar.opcoes-avancadas';
export const __ESCOLA_EXPORTAR = '__ol-mirim.escola.exportar';

export const __COORDENADOR_VISUALIZAR = '__ol-mirim.coordenador.visualizar';
export const __COORDENADOR_EXPORTAR = '__ol-mirim.coordenador.exportar';
export const __COORDENADOR_EDITAR_SENHA = '__ol-mirim.coordenador.editar.senha';
export const __COORDENADOR_EDITAR_MATERIAL_EXTRA = '__ol-mirim.coordenador.editar.material-extra';

export const __TIPO_DOCUMENTO_EDITAR = '__ol-mirim.tipo-documento.editar';